<template>
  <div class="material-upload-result">
    <div class="batch-upload-step-four">
      <div class="step-four-info">
        <div class="info-left">
          <div class="info-left-top-material">
            <img src="@/assets/image/batch-upload-dialog/ic_attend.png">
            <div class="info-left-tip">
              <div>
                <span class="span-text">成功匹配</span><span
                class="span-info">{{ matchedCaseCount ? matchedCaseCount : 0 }}个案件</span>
                <span class="span-text">，共计
                  <span class="span-info">{{ matchedCaseFileCount ? matchedCaseFileCount : 0 }}个文件</span>
                  （成功匹配到案件的文件夹下的所有文件）</span>
                <span class="span-text">，成功上传</span>
                <span class="span-info">{{ successFileCount ? successFileCount : 0 }}个文件。</span>
                <!--                <span class="span-text"><span class="span-info"></span>因不符合文件打包路径，未匹配到案件</span>-->

              </div>
              <div class="result-case-div">
                <span class="span-err">{{ notMatchedFileCount ? notMatchedFileCount : 0 }}个文件<span class="span-text">因不符合文件打包路径，未匹配到案件</span></span>

              </div>
              <div class="result-btn-div">
                <button class="btn-retry" @click.stop="clickRetry">再次上传</button>
                <button class="btn-download" v-show="tableList.length>0" @click="downLoadRecord">下载失败记录</button>
              </div>
            </div>
          </div>
        </div>
        <div class="info-line"></div>
        <div class="info-right">
              <span class="info-right-inner"><span class="info-right-tip">数据包规范说明：</span><br/>
                1、请按照一个案件一个文件夹的方式整理文书，文件夹以被申请人名称命名；<br/>
                2、上传文书应为PDF、word格式，单个大小0KB以上，50M以下<br/>
              3、文件名称按照文书类型进行命名<br/>
              4、文件名称中请勿包含换行符、空格、tab#&\/:?"<>*|＼：？＃＊｜＆＂＜＞%+' 特殊字符。<br/>
              5、文件名称不超过45个字<br/>
              6、为避免出现程序性错误，系统将自动对您文件名中的隐藏字符进行删除，请您知悉！<br/>
              具体规范可参照样本范例
              </span>
          <img class="img-float-bg" src="@/assets/image/batch-upload-dialog/bg.png">
          <button class="btn-load-temp" @click="downLoadTemp">下载范本</button>
        </div>
      </div>
      <el-table class="step-four-table"
                :data="tableList"
                :max-height="tableHeight"
                style="margin-top: 20px; width: 100%;">
        <el-table-column
          fixed="left"
          :show-overflow-tooltip="false"
          label="被申请人"
          prop="dftName">
        </el-table-column>
        <el-table-column
          v-if="isDocUpload"
          :show-overflow-tooltip="true"
          fixed="left"
          width="200px"
          label="案号"
          prop="caseNo">
        </el-table-column>
        <el-table-column
          v-if="isDocUpload"
          :show-overflow-tooltip="true"
          fixed="left"
          label="申请人"
          prop="applicant">
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="false"
          fixed="left"
          align="left"
          :width="isDocUpload?'400px':'600px'"
          label="错误详情"
          prop="err">
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              width="500"
              trigger="hover"
              popper-class="table-popover-container">
              <div class="table-popover" v-dompurify-html="scope.row.err">
              </div>
              <p class="tab-col-err tab-single-line"
                 style="width: auto;"
                 slot="reference">
                {{ scope.row.errText }}
              </p>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :layout="layout"
        :total="queryPage.total"
        :current-page="queryPage.pageNo"
        :page-size="queryPage.pageSize">
      </el-pagination>

    </div>
  </div>
</template>

<script>
import {getUrlKey} from '@/assets/js/tool';

export default {
  name: 'material-upload-result',
  props: {
    allUploadCount: {
      type: String | Number,
      default: '0'
    },
    isSingleCase: {
      type: Boolean,
      default: false,
    },
    isDocUpload: {
      type: Boolean,
      default: false,
    },
    // 列表批量上传必要参数
    queryParams: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      successFileCount: 0,
      failFileCount: 0,
      matchedCaseFileCount: 0,
      matchedCaseCount: 0,
      notMatchedFileCount: 0,
      tableHeight: '400px',
      tableList: [],
      jsonExcelFields: {
        '被申请人': 'dftName',
        '案号': 'caseNo',
        '申请人': 'applicant',
        '错误详情': 'err',
      },
      queryPage: {
        taskId: '',
        pageNo: 1,
        pageSize: 10,
        totalPage: 1,
        total: 0,
        matchSuccess: false,
      }, // 分页参数
      layout: 'prev, pager, next',
    };
  },
  mounted() {
    this.setTableHeight();
  },
  beforeDestroy() {
    this.$bus.$emit('closeMaterialUploadResult');
  },
  computed: {
    isAgentRule() {
      // 获取url中的参数
      const system = getUrlKey('system', window.location.href);
      return system && system.indexOf('brt') > -1 || JSON.parse(sessionStorage.getItem('vuex')).user.activeRoleName === '案件管理员';
    },
    exportFileType() {
      // 材料
      let type = 'brt';
      if (window.location.href.indexOf('sfqr') > -1 || window.location.href.indexOf('brt-judicial-confirmation-detail') > -1) {
        // 司法确认
        type = 'judicial';
      } else if (this.isDocUpload) {
        // 文书
        type = 'offline';
      }
      return {type, caseChannel: this.queryParams.params.caseChannel || ''};
    }
  },
  methods: {
    setTableHeight() {
      const height = window.innerHeight - 565;
      this.tableHeight = `${height}px`;
    },
    downLoadTemp() {
      this.$api.downLoadBatchUploadTemp(this.exportFileType).then(res => {
        if (res && res.code == 200 && res.data) {
          this.$utils.downloadFile(res.data);
        }
      }, err => {

      });

      // this.tableList.push({
      //   dftName: '测试结果',
      //   err: '测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测' +
      //     '试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长测试内容超级长'
      // })
    },

    downLoadRecord() {
      if (this.queryPage.taskId) {
        window.open(`${this.$api.downLoadTaskDetail}?taskId=${this.queryPage.taskId}`);
      }
    },

    clickRetry() {
      this.queryPage = this.$options.data().queryPage;
      this.tableList = [];
      this.$emit('clickRetry');
    },

    /**
     * 切换分页数量
     * @param { Number } pageSize 页数
     */
    sizeChange(pageSize) {
      this.queryPage.pageNo = 1;
      this.queryPage.pageSize = pageSize;
      this.queryRequest();
    },

    /**
     * 切换页码
     * @param { Number } pageIndex 页码
     */
    currentChange(pageIndex) {
      this.queryPage.pageNo = pageIndex;
      this.queryRequest();
    },

    showResult(taskId, complete, matchData) {
      this.setTableHeight();
      if (matchData) {
        // this.allUploadCount = matchData.totalCount
        this.failFileCount = matchData.failCount;
        this.successFileCount = matchData.successCount;
        this.matchedCaseCount = matchData.matchedCaseCount;
        this.matchedCaseFileCount = matchData.matchedCaseFileCount;
        this.notMatchedFileCount = matchData.notMatchedFileCount;
      }
      this.queryPage = this.$options.data().queryPage;
      this.queryPage.taskId = taskId || '';
      // 开启查询
      if (this.queryPage.taskId) {
        this.queryRequest(complete);
      } else {
        complete ? complete() : '';
      }
    },

    queryRequest(complete) {
      this.$api.queryFileMatchTaskDetails(JSON.stringify(this.queryPage)).then(res => {
        complete ? complete() : '';
        if (res && res.code == 200 && res.data) {
          const data = res.data;
          this.queryPage.totalPage = data.totalPage ? data.totalPage : 1;
          this.queryPage.total = data.total ? data.total : 0;
          if (res.data.record && res.data.record.length > 0) {
            // if (this.queryPage.pageNo == 1) {
            this.tableList = [];
            // }

            if (this.isSingleCase) {
              let endErr = '';
              let errText = '';
              res.data.record.forEach(item => {
                endErr = parserErrorList(item.errorMessageList);
                errText = parserErrorList(item.errorMessageList, false);
              });
              this.tableList.push({
                dftName: res.data.record[0].dftName,
                caseNo: res.data.record[0].caseNo,
                applicant: res.data.record[0].applicant,
                err: endErr,
                errText
              });
            } else {
              res.data.record.forEach(item => {
                const err = parserErrorList(item.errorMessageList);
                const errText = parserErrorList(item.errorMessageList, false);
                if (item.dftName || item.applicant) {
                  this.tableList.push({
                    err: err || item.desc,
                    ...item,
                    errText
                  });
                }
              });
            }
          }
        }

        function parserErrorList(errList, tagFlag = true) {
          if (errList && errList.length > 0) {
            let content = '';
            if (tagFlag) {
              errList.forEach(err => {
                content += `<p style="padding: 14px 0">${err}</p>`;
              });
            } else {
              errList.forEach(err => {
                content += err;
              });
            }

            return content;
          } else {
            return '';
          }
        }
      }, err => {
        complete ? complete() : '';
      });
    }
  },

};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

.info-left-top-material {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    height: 100%;

    > img {
        margin-right: 12px;
        width: 48px;
        height: 48px;
    }
}

.info-left-tip {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
}

.result-case-div {
    margin-top: 16px;
    margin-bottom: 16px;
}

.result-btn-div {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 32px;
}

.btn-retry {
    width: 147px;
    height: 36px;
    color: #0d0d0d;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    line-height: 16px;
    border-radius: 2px;
    border: 1px solid #eee;
    background: #fff;
}

.btn-download {
    margin-top: 8px;
    width: 147px;
    height: 36px;
    color: #fff;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    line-height: 16px;
    border-radius: 2px;
    border: 0;
    background: #274ea4;
}

.tab-single-line {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.table-popover {
    max-width: 500px;
    max-height: 400px;
    overflow-y: auto;
    word-break: break-all;
    //>p{
    //  width: 484px;
    //  word-break: break-all;
    //}
}

.batch-upload-step-four {
    .info-right-inner {
        color: #666;
    }

    .info-right-tip {
        color: #333;
    }

    .span-err {
        .span-text {
            color: #777;
        }
    }
}

.pagination {
    padding-top: 16px;
}
</style>
